// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8":"507f8e1d","563":"afccb308"}[chunkId] + ".chunk.css";
};